var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-0",
    clipPath: "url(#clip0_1003_1647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C24.8375 32 32 24.8375 32 16C32 7.1625 24.8375 0 16 0ZM16 30C8.28125 30 2 23.7188 2 16C2 8.28125 8.28125 2 16 2C23.7188 2 30 8.28125 30 16C30 23.7188 23.7188 30 16 30ZM16 8C12.6938 8 10 10.6938 10 14V18C10 21.3088 12.6912 24 16 24C19.3088 24 22 21.3088 22 18V14C22 10.6938 19.3062 8 16 8ZM20 18C20 20.205 18.205 22 16 22C13.795 22 12 20.205 12 18V14C12 11.795 13.795 10 16 10C18.205 10 20 11.795 20 14V18Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_1647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.696dc5953f7007698e96e2ef3fe9bcd2.svg";
export { ForwardRef as ReactComponent };